export default __webpack_public_path__ + "static/media/grocery.50628eae.PNG";